export default {
  // Tab标签
  notificationCenter_00001: "故障",
  notificationCenter_00002: "维护",
  
  // 列表表头
  notificationCenter_00003: "发送时间",
  notificationCenter_00004: "SN",
  notificationCenter_00005: "场站",
  notificationCenter_00006: "故障码",
  notificationCenter_00007: "收件地址",
  notificationCenter_00008: "状态",
  
  // 状态值
  notificationCenter_00009: "待处理",
  notificationCenter_00010: "已发送",
  notificationCenter_00011: "失败",
  
  // 按钮和操作
  notificationCenter_00012: "查看",
  notificationCenter_00013: "搜索",
  
  // 搜索框占位符
  notificationCenter_00014: "输入设备名称或SN",
  notificationCenter_00015: "全部场站",
  
  // 弹窗相关
  notificationCenter_00016: "邮件通知",
  notificationCenter_00017: "发送时间:",
  notificationCenter_00018: "类型:",
  notificationCenter_00019: "故障告警",
  notificationCenter_00020: "SN:",
  notificationCenter_00021: "场站:",
  notificationCenter_00022: "故障码:",
  notificationCenter_00023: "收件人:",
  notificationCenter_00024: "邮件内容",
  notificationCenter_00025: "关闭",
};
